// src/config/buyerPersonaConfig.js
export const BUYER_PERSONA_CONFIG = {
    // Endpoints de la API
    ENDPOINTS: {
        QUESTIONS: 'buyer-persona/quiz/questions',
        CREATE: 'buyer-persona/quiz',
        UPDATE: 'buyer-persona/quiz',
        GET_RESULT: 'buyer-persona/result/complete',
        IMAGE_STATUS: 'buyer-persona/result/with-image',
        GET_IMAGE: 'buyer-persona/image',
        REGENERATE_IMAGE: 'buyer-persona/image/regenerate',
        DELETE: 'buyer-persona/result'
    },

    // Configuración temporal
    TEMP: {
        // Si el backend no está disponible, usar datos mock
        USE_MOCK_DATA: false,

        // Simular delay de red
        NETWORK_DELAY: 0,

        // Mensajes de error amigables
        ERROR_MESSAGES: {
            QUESTIONS_NOT_AVAILABLE: 'Error al cargar las preguntas del cuestionario',
            SUBMIT_NOT_AVAILABLE: 'Error al procesar el cuestionario',
            PERSONA_NOT_AVAILABLE: 'Error al cargar el buyer persona',
            IMAGE_GENERATION_FAILED: 'Error al generar la imagen'
        }
    },

    // Configuración de UI
    UI: {
        MODULE_TRANSITION_DELAY: 300,
        LOADING_ANIMATION_DURATION: 1000,
        MAX_RETRIES: 3,
        POLLING_INTERVAL: 3000, // 3 segundos
        POLLING_TIMEOUT: 120000 // 2 minutos
    },

    // Módulos del cuestionario
    MODULES: {
        NEGOCIO: 'negocio',
        CLIENTE: 'cliente',
        MOTIVACIONES: 'motivaciones',
        COMPORTAMIENTO: 'comportamiento',
        COMUNICACION: 'comunicacion',
        OBJECIONES: 'objeciones'
    },

    // Títulos de los módulos
    MODULE_TITLES: {
        negocio: 'Información del Negocio',
        cliente: 'Datos del Cliente Actual',
        motivaciones: 'Motivaciones y Necesidades',
        comportamiento: 'Comportamiento y Consumo',
        comunicacion: 'Comunicación y Estilo',
        objeciones: 'Objeciones y Barreras'
    },

    // Estados de la imagen
    IMAGE_STATUS: {
        PENDING: 'pending',
        GENERATING: 'generating',
        COMPLETED: 'completed',
        FAILED: 'failed'
    }
}; 